import timeOffInputStore from "../store/store";
import { mutatorAction } from "satcheljs";

export default mutatorAction('SET_THEME', function setThemeInStore(theme: string) {
    timeOffInputStore.theme = theme;
});
